import { createWrapper } from 'next-redux-wrapper';

import { configureAppStore } from './configure-app-store';

export const nextWrapper = createWrapper(configureAppStore);
